import { ControlParams } from "./ControlInterfaces";
import { Label } from "./Label";

/**
 * Label, zobrazující prostý text bez lokalizací
 */
export class SimpleLabel extends Label {
    /** Zobrazovaný text */
    public get text(): string {
        return this.innerElement.textContent;
    }

    /** Zobrazovaný text */
    public set text(value: string) {
        this.innerElement.textContent = value;
    }

    constructor(params: ControlParams) {
        super(params);

        this.innerElement = document.createElement("label");
        this.innerElement.classList.add(this._getClassByLevel(this._headingLevel));
        this.element.appendChild(this.innerElement);
        this.text = this.getDataAttr("text");
    }
}
